export const GLOBAL_NAV_HEIGHT = 64;
